import React from 'react';
import Watch from './components/Watch';

function App() {
  return (
    <div className="container">
      <h1>Stopwatch</h1>
      <Watch/>
    </div>
  );
}

export default App;
